import _ from 'underscore'
import axios from 'axios'
import store from '../state/store'

store.on('orders:index', function(enquiry_id) {
  const params = {
    enquiry_id: enquiry_id
  }

  axios.get("/api/sales/orders", {params: params})
  .then((response) => {
    store.get().set({orders: response.data.orders})
  })
  .catch((error) => {
    handleError(error)
  })
})

store.on('orders:combine', function(params) {
  axios.post(`/api/sales/orders/combine_orders`, params)
  .then((response) => {
    store.emit('orders:index', params.enquiry_id)
    showMessage('Orders combined!')
  })
  .catch((error) => {
    handleError(error)
  })
})

store.on('orders:delete', function(params) {
  axios.delete(`/api/sales/orders/${params.order_id}`)
  .then((response) => {
    store.emit('orders:index', params.enquiry_id)
    showMessage(`Order ${params.order_id} deleted.`)
  })
  .catch((error) => {
    handleError(error)
  })
})

store.on('orders:share', function(params) {
  axios.put(`/api/sales/orders/${params.order_id}/share`)
  .then((response) => {
    store.emit('orders:index', params.enquiry_id)
    showMessage('Order shared.')
  })
  .catch((error) => {
    handleError(error)
  })
})
